'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink = require('@narvar/nth-bit-text-link');
var Button = require('@narvar/nth-block-button');
var PanelContentHeader = require('@narvar/nth-block-panel-content-header');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Spinner = require('@narvar/nth-bit-icon-spinner');
var ControlView_module = require('./ControlView.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var PanelContentHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelContentHeader);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);

const ControlView = ({
  channel,
  isLandscape,
  featureName,
  icon,
  heading,
  text,
  primaryButton,
  secondaryButton
}) => {
  const {
    linksNoneDefault: unsubscribeLinkStyle,
    linksNoneHover: unsubscribeLinkHoverStyle
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ControlView_module["default"].controlView,
    "data-test": `${channel}NotificationCenterSubscribed`
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-one-${isLandscape ? '7' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '7' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? ControlView_module["default"].panelContainerLandscape : ControlView_module["default"].panelContainer
  }, /*#__PURE__*/React__default["default"].createElement(PanelContentHeader__default["default"], {
    as: "h2",
    icon: icon,
    headerText: heading || '',
    headerTextRole: "status",
    featureName: featureName,
    paragraphChildren: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, text, secondaryButton && isLandscape && /*#__PURE__*/React__default["default"].createElement("span", {
      className: ControlView_module["default"].unsubscribeWrapperLandscape
    }, secondaryButton.loading ? /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
      linkStyle: {
        sDefault: unsubscribeLinkStyle,
        sHover: unsubscribeLinkHoverStyle
      },
      onClick: secondaryButton.onClick
    }, secondaryButton.text))),
    isLandscape: isLandscape
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-two-${isLandscape ? '5' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '5' : '12'}`
    }
  }, primaryButton && /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? ControlView_module["default"].buttonContainerLandscape : ControlView_module["default"].buttonContainer,
    "data-test": `${channel}UpdateInfoButtonContainer`
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    featureName: featureName,
    onClick: primaryButton.onClick,
    big: !isLandscape,
    disabled: primaryButton.disabled
  }, primaryButton.text)), secondaryButton && !isLandscape && /*#__PURE__*/React__default["default"].createElement("div", {
    className: ControlView_module["default"].unsubscribeWrapper,
    "data-test": `${channel}UnsubscribeLinkContainerPortrait`
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: ControlView_module["default"].unsubscribeWrapper
  }, secondaryButton.loading ? /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: unsubscribeLinkStyle,
      sHover: unsubscribeLinkHoverStyle
    },
    href: secondaryButton.link,
    onClick: secondaryButton.onClick
  }, secondaryButton.text)))));
};
const themeProvider = component => nthHookTheme.withThemeProvider(component, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});
var ControlView$1 = themeProvider(ControlView);

exports["default"] = ControlView$1;
